import { useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import { ContentBody, ContentHeader } from 'components/shared/content'
import * as H from 'history'
import { ActionTableCell, ExTable, TableBody, TableHead, TableWrapper } from 'components/shared/widget'
import { Probe, ProbeSearchForm } from 'entities/probe'
import { useDeleteProbeApi, useFetchProbesApi } from 'api/probe'
import { probeColumnInfoList, ProbeTableData } from './probe_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { Pagination } from 'components/shared/pagination'
import { EditProbeForm, NewProbeForm } from './probe_form'
import { useState } from 'react'
import { SearchConditionView } from 'components/shared/search_drawer'
import { ProbeStockModal } from './probes_modal'

type Props = {
    history: H.History
}

const ProbesPage = (props: Props) => {
    const query = useQuery<ProbeSearchForm>()
    const searchForm = useForm<ProbeSearchForm>({ ordering: '-probe_created_at', ...query })
    const listApi = useFetchProbesApi(searchForm)
    const globalState = useContext(GlobalStateContext)
    const probeDisplaySetting = useDisplaySetting(probeColumnInfoList(searchForm), 'Probe')
    const deleteApi = useDeleteProbeApi()
    const [showEdit, setShowEdit] = useState<boolean>(false)
    const [selectedProbe, setSelectedProbe] = useState<Probe>({})
    const [showStocks, setShowStocks] = useState<boolean>(false)

    useEffect(() => {
        listApi.execute()
    }, [])

    useEffectSkipFirst(() => {
        globalState.setLoading(deleteApi.loading)
        if (deleteApi.isSuccess()) {
            listApi.execute()
        }
    }, [deleteApi.loading])

    const handleClickRemoveFilter = (key: keyof ProbeSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    return (
        <>
            <ProbeStockModal
                show={showStocks}
                probe={selectedProbe}
                onClose={() => {
                    setShowStocks(false)
                }}
            />
            <EditProbeForm
                show={showEdit}
                probe={selectedProbe}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    setShowEdit(false)
                    listApi.execute()
                }}
            />
            <ContentHeader
                headerTitle="Probes"
                left={
                    <>
                        <NewProbeForm onComplete={() => listApi.execute()} />
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
                right={
                    <>
                        <Pagination pageSet={listApi.pageSet} response={listApi.response}></Pagination>
                    </>
                }
            />
            <ContentBody>
                <TableWrapper>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <tr>
                                <ActionTableCell th></ActionTableCell>
                                <ActionTableCell th></ActionTableCell>
                                <TableHeads displaySetting={probeDisplaySetting} />
                            </tr>
                        </TableHead>
                        <TableBody loading={listApi.loading}>
                            {listApi.response.results.map((probe: Probe) => {
                                return (
                                    <tr key={probe.id}>
                                        <ActionTableCell
                                            action={'delete'}
                                            onClick={() => {
                                                globalState.showConfirm('本当に削除しますか？(すでにStudyで使われている場合は削除できません)', () => {
                                                    deleteApi.execute(probe.id!)
                                                })
                                            }}
                                        />
                                        <ActionTableCell
                                            action={'edit'}
                                            onClick={() => {
                                                setSelectedProbe(probe)
                                                setShowEdit(true)
                                            }}
                                        />
                                        <ProbeTableData
                                            probe={probe}
                                            displaySetting={probeDisplaySetting}
                                            onClickStocks={(probe) => {
                                                setSelectedProbe(probe)
                                                setShowStocks(true)
                                            }}
                                        />
                                    </tr>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={listApi.pageSet} response={listApi.response}></Pagination>
                </TableWrapper>
            </ContentBody>
        </>
    )
}

export default withRouter(ProbesPage)
